import { useTranslations } from 'next-intl';
import { IMarketing, IProduct } from '@monofront/types';
import { NUTRITIONAL_VALUES_AS_TEXT } from '@monofront/business/constants';
import { useProductLayout } from '@monofront/business/hooks';
import { getIsPetProduct, getNutritionValues } from '@monofront/business/utils';
import { mapNutrionalValues } from '@screens/ProductDeprecated/Nutrition/mapNutrition';

interface IProductNutritionalValuesProps {
  product: IProduct;
  marketing: IMarketing;
  unitOfMeasurement?: string;
  tags: string[];
}

const ProductNutritionalValues: React.FC<IProductNutritionalValuesProps> = ({
  product,
  marketing: {
    nutritional_values_table_data,
    nutritional_values,
    nutritional_values_as_text,
  },
  unitOfMeasurement,
  tags,
}) => {
  const tProducts = useTranslations('Products');
  const { nutritionalValues: nutritionalValuesTranslations } =
    useProductLayout();

  const isPetProduct = getIsPetProduct(tags, product.product_subtype);
  const nutritionalValues = getNutritionValues(nutritional_values_table_data);
  const NUTRITIONAL_VALUES = mapNutrionalValues(nutritionalValuesTranslations);

  if (
    (!nutritional_values && !nutritional_values_table_data) ||
    nutritional_values === 'NA' ||
    (NUTRITIONAL_VALUES_AS_TEXT.FALSE === nutritional_values_as_text &&
      nutritionalValues?.body?.length === 0)
  )
    return null;

  return (
    <>
      <h3 className="tw-lf-body-xbold-md tw-mb-2 tw-mt-6">
        {isPetProduct
          ? tProducts('constituents')
          : tProducts('nutritionalValues', { base: unitOfMeasurement })}
      </h3>

      {NUTRITIONAL_VALUES_AS_TEXT.TRUE === nutritional_values_as_text ? (
        <p>{nutritional_values}</p>
      ) : (
        <>
          {nutritionalValues?.body?.length > 0 && (
            <table
              className={`
            tw-w-full tw-max-w-[486px] tw-border-collapse
          `}
            >
              <tbody>
                {nutritionalValues.body.map((element) => {
                  const lineTitle = NUTRITIONAL_VALUES[element[0]] || '';
                  const isInclusion =
                    lineTitle.startsWith('dont') ||
                    lineTitle.startsWith('davon');

                  return (
                    <tr key={element[0]} className="odd:tw-bg-blue-100">
                      <th
                        scope="row"
                        className={`
                      tw-px-0.5 tw-py-1 tw-text-left tw-font-normal ${
                        isInclusion ? 'tw-pl-4' : ''
                      }`}
                      >
                        {lineTitle}
                      </th>
                      <td className="tw-px-0.5 tw-py-1 tw-text-right">
                        {element[1].replace('.', ',')}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          {nutritionalValues?.footer?.map((element: string, index: number) => (
            <p key={index} className="tw-lf-body-regular-sm">
              *{element}
            </p>
          ))}
        </>
      )}
    </>
  );
};

export default ProductNutritionalValues;
